export default "__VITE_ASSET__Cp4s69er__"